import React, {FC} from "react";
import {
	CompletionCelebrationContentDrawer
} from "@/pages/CoursePage/CourseCompletionCelebration/CompletionCelebrationContentDrawer";
import {
	CompletionCelebrationContentModal
} from "@/pages/CoursePage/CourseCompletionCelebration/CompletionCelebrationContentModal";
import {useMq} from "@buildwitt/shapeshift-common/v1/hooks";

interface IProps {
	open: boolean;
	onClose: (needsToContinue: boolean) => void;
}

export const CompletionCelebrationWrap: FC<IProps> = ({open, onClose}) => {
	const mq = useMq();
	return (
		<>
			{mq.mobile ? <CompletionCelebrationContentDrawer open={open} onClose={(needsToContinue) => onClose?.(needsToContinue)}/> : <CompletionCelebrationContentModal open={open} onClose={(needsToContinue) => onClose?.(needsToContinue)}/>}
		</>
	);
};
